import baseRoute from '../baseRoute';

export default `${baseRoute}/dailyTip` as const;
